import { Card } from '@iwoca/orion';
import cn from 'classnames';

import styles from './SellerDashboardStatusSummary.module.css';
import { LinkWithQuery } from '../../../../components/LinkWithQuery/LinkWithQuery';
import {
  PayLinkStatus,
  usePayLinks,
} from '../../../Payments/hooks/usePaylinks.hook';

export const SellerDashboardStatusSummary = () => {
  const { statusAggregate } = usePayLinks();

  const constructStatusLink = (status: PayLinkStatus) => {
    return `${BASE_PAYMENTS_ROUTE}?status=${status}`;
  };

  const BASE_PAYMENTS_ROUTE = '/pay/payments';
  return (
    <Card className={styles.container}>
      <div className={styles.title}>Your payment statuses</div>
      <div className={styles.body}>
        <div className={styles.summaryCardContainer}>
          <SummaryCard
            number={statusAggregate?.SIGNED_UP}
            text="Signed up"
            className={styles.signedUp}
            link={constructStatusLink('SIGNED_UP')}
          />
        </div>
        <div className={styles.summaryCardContainer}>
          <SummaryCard
            number={statusAggregate?.DECLINED}
            text="Declined"
            className={styles.declined}
            link={constructStatusLink('DECLINED')}
          />
        </div>
        <div className={styles.summaryCardContainer}>
          <SummaryCard
            number={statusAggregate?.APPROVED}
            text="Approved"
            className={styles.approved}
            link={constructStatusLink('APPROVED')}
          />
        </div>
        <div className={styles.summaryCardContainer}>
          <SummaryCard
            number={statusAggregate?.PAID}
            text="Paid"
            className={styles.paid}
            link={constructStatusLink('PAID')}
          />
        </div>
      </div>
    </Card>
  );
};

const SummaryCard = ({
  text,
  link,
  number,
  className,
}: {
  text: string;
  link: string;
  number?: number;
  className?: string;
}) => {
  const cardNumber = typeof number === 'number' ? number.toString() : '';

  return (
    <LinkWithQuery className={styles.summaryCardLink} to={link}>
      <Card className={cn(styles.summaryCard, className)}>
        <div className={styles.summaryCardNumber}>{cardNumber}</div>
        <div className={styles.summaryCardText}>{text}</div>
      </Card>
    </LinkWithQuery>
  );
};
